// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01b66{margin-left:var(--ds-space-050,4px)}\n._19bvxy5q{padding-left:var(--ds-space-400,2pc)}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._u5f3xy5q{padding-right:var(--ds-space-400,2pc)}", ""]);
// Exports
module.exports = exports;
